import React, { useState, useEffect } from 'react';
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from '../components/PopUP';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd'
import { Link, useLocation } from "react-router-dom";
import api from '../Api';
import MarkdownText from "../components/MarkdownText";

const letters = ["A", "B", "C", "D"];
const BlackBoxListDetails = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  const [questions, setQuestions] = useState([])
  const [questionId, setQuestionId] = useState([])
  const [isApproved, setIsApproved] = useState([])
  const [summaries, setSummary] = useState([])
  const [editForm, setEditForm] = useState(null);
  const [editSummaryForm, setEditSummaryForm] = useState(null);
  const [updating, setUpdating] = useState(false);

  const pathParts = pathname.split("/").filter(Boolean);

  const level = pathParts[3];
  const location = useLocation();
  const [hash, setHash] = useState();
  

  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await api.get(`blackbox/admin/question/${level}`);
        setQuestions(response.data.question);
        setSummary(response.data.summary);
        setQuestionId(response.data.question_id);
        setIsApproved(response.data.is_approved);
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false);

      const question_id = location.hash.substring(1);
      setHash(question_id);

      // Scroll to element after a delay
      setTimeout(() => {
        const element = document.getElementById(question_id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);

    };

    fetchData();
  }, [pathname, location.hash]);

  const allQuestions =
    questions?.category_types?.flatMap((category) =>
      category.questions.map((question) => ({
        ...question,
        categoryType: category.type,
        categoryName: category.name,
        level: questions.level,
        difficulty: questions.difficulty,
        game: questions.game,
      }))
    ) ?? [];


  const updateQuestion = async () => {
    if (!editForm) return;

    const confirmModalEl = document.getElementById("confirmUpdateModal");
    if (confirmModalEl) {
      const confirmInstance =
        window.bootstrap.Modal.getInstance(confirmModalEl);
      confirmInstance?.hide();
    }
    setUpdating(true);

    try {
      const payload = {
        set_id: level,
        action_no: editForm.action_no,
        question_id: editForm.question_id,
        explanation: editForm.explanation,
        question: editForm.question,
        title: editForm.title,
        options: editForm.options,
        answer: editForm.answer,
      };

      await api.patch(`blackbox/admin/update-question`, payload);

      setPopupMessage("Question updated successfully");

      // Update UI without refetch
      setQuestions((prev) => {
        if (!prev) return prev;

        return {
          ...prev,
          category_types: prev.category_types.map((cat) => ({
            ...cat,
            questions: cat.questions.map((q) =>
              q.question_id === editForm.question_id
                ? { ...q, ...editForm }
                : q
            ),
          })),
        };
      });
      const modalEl = document.getElementById(
        `editModal-${editForm.question_id}`
      );

      if (modalEl) {
        const modalInstance =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);

        modalInstance.hide();
      }
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to update question");
    } finally {
      setUpdating(false);
    }
  };

  const udpateSummary = async () => {
    if (!editSummaryForm) return;

    setUpdating(true);
    try {
      const payload = {
        title: editSummaryForm.title,
        expantion: editSummaryForm.expantion,
        type: editSummaryForm.type,
        question_id: editSummaryForm.question_id,
        set_id: level,
      };

      await api.patch(`blackbox/admin/update-summary`, payload);

      setPopupMessage("Question updated successfully");

      // Update UI without refetch
      setSummary((prev) => {
        if (!prev) return prev;

        return prev.map((item) =>
          item.question_id === editSummaryForm.question_id
            ? { ...item, ...editSummaryForm }
            : item
        );
      });

      const modalEl = document.getElementById(
        `editModal-${editSummaryForm.question_id}`
      );

      if (modalEl) {
        const modalInstance =
          window.bootstrap.Modal.getInstance(modalEl) ||
          new window.bootstrap.Modal(modalEl);

        modalInstance.hide();
      }
    } catch (err) {
      console.error(err.message);
      setPopupMessage("Failed to update question");
    } finally {
      setUpdating(false);
    }
  };


  const overviewSummary = summaries?.filter(
    (item) => item.type === "overview"
  ) || [];
  const clueDesk =
    summaries?.filter((item) => item.type !== "overview") || [];


  const approveQuestionSet = async () => {
    setLoading(true);
    try {
      const payload = {
        set_id: level,
        action: 'approve',
      };

      await api.patch('blackbox/admin/question-action', payload);
      setPopupMessage("Question approved successfully");
    } catch (err) {
      console.error(err);
      setPopupMessage("Failed to approved set questions");
    }
    setLoading(false);
  };


  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <nav className="breadcrumb_nav">
                          <ul className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><Link to='../game-management/black-box-game'>Black Box</Link></li>
                            <li className="breadcrumb-item"><Link to={`../game-management/black-box-game/${pathParts[2]}`}>
                              {pathParts[2].replace("_", " ").replace(/^./, c => c.toUpperCase())}</Link></li>
                            <li className="breadcrumb-item text-capitalize">{questionId}</li>
                          </ul>
                        </nav>
                        <h1 className='mb-2 mt-3'>Black Box Game</h1>
                      </div>
                    </div>
                  </div>

                  {/* Overview */}
                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>Overview</h2>
                        </div>
                      </div>
                      {!isApproved && (
                        <div className="common-right-blk">
                          <div className="common-sort-blk">
                            <button
                              className="secondary_btn py-2 fs-14"
                              onClick={approveQuestionSet}
                            >
                              Approve and Publish
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='common_content_blk'>
                      <div className='row row-cols-1 g-3'>
                        <div className='col'>
                          <div className='quiz_card_wrapper'>
                            {overviewSummary.map((item) => (

                              <div className='vstack align-items-center gap-3'>
                                <div key={item.question_id} className="flex-grow-1">
                                  <div className="hstack justify-content-between align-items-start gap-3 mb-2">
                                    <h3 className="mb-0 fs-2">{item.title}</h3>

                                    <button
                                      className="secondary_btn py-1 fs-14"
                                      data-bs-toggle="modal"
                                      data-bs-target={`#editModal-${item.question_id}`}
                                      onClick={() =>
                                        setEditSummaryForm({
                                          title: item.title,
                                          expantion: item.expantion,
                                          type: item.type,
                                          question_id: item.question_id,
                                        })
                                      }
                                    >
                                      <i className="fa-solid fa-pencil me-2"></i> Edit
                                    </button>
                                  </div>

                                  <p className="mb-0">{item.expantion}</p>
                                </div>
                                <div className='mt-4'>
                                  {/* <-- Edit Question Modal --> */}
                                  <div className="modal fade" id={`editModal-${item.question_id}`} data-bs-backdrop="static"
                                    data-bs-keyboard="false" tabindex="-1" aria-labelledby="overviewLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h1 className="modal-title fs-5" id="overviewLabel">Overview</h1>
                                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="px-4">
                                            <div className="form_field">
                                              <label className="fs-14">Title</label>
                                              <div className="input_field">
                                                <input className="form-control" placeholder="Edit Answer.." type="text"
                                                  value={editSummaryForm?.title || ""}
                                                  onChange={(e) =>
                                                    setEditSummaryForm({
                                                      ...editSummaryForm,
                                                      title: e.target.value,
                                                    })
                                                  } />
                                              </div>
                                            </div>
                                            <div className="form_field">
                                              <label className="fs-14">Description</label>
                                              <div className="input_field">
                                                <textarea className="form-control" rows="4" placeholder="Edit Descripion.." name="Edit Descripion.."
                                                  value={editSummaryForm?.expantion || ""}
                                                  onChange={(e) =>
                                                    setEditSummaryForm({
                                                      ...editSummaryForm,
                                                      expantion: e.target.value,
                                                    })
                                                  } />
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                        <div className="modal-footer border-0 justify-content-center">
                                          <button type="button" className="btn btn-secondary rounded-5 fs-14" data-bs-dismiss="modal">Cancel</button>
                                          <button type="button" className="secondary_btn py-2 px-4 fs-14" onClick={udpateSummary}>Update</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  {/* Clue Desk */}
                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>ClueDesk</h2>
                        </div>
                      </div>
                    </div>
                    <div className='common_content_blk'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-3'>
                        {clueDesk.map((item) => (
                          <div className='col' id={item.question_id} key={item.question_id}>
                            <div className='quiz_card_wrapper'>
                              <div className='vstack align-items-center gap-3'>
                                <div className='flex-grow-1' key={item.question_id}>
                                  <div className='hstack justify-content-between align-items-start gap-3 mb-2'>
                                    <h3 className='mb-0'>{item.title}</h3>
                                    <button className="secondary_btn py-1 fs-14" data-bs-toggle="modal"
                                      data-bs-target={`#editModal-${item.question_id}`}
                                      onClick={() =>
                                        setEditSummaryForm({
                                          title: item.title,
                                          expantion: item.expantion,
                                          type: item.type,
                                          question_id: item.question_id,
                                        })
                                      }
                                    ><i className="fa-solid fa-pencil me-2"></i> Edit</button>
                                  </div>
                                  <p className='mb-0'>{item.expantion}</p>
                                </div>
                                <div className='mt-4'>
                                  {/* <-- Edit Question Modal --> */}
                                  <div className="modal fade" id={`editModal-${item.question_id}`} data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropClueDeskLabel" aria-hidden="true">
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h1 className="modal-title fs-5" id="staticBackdropClueDeskLabel">Overview</h1>
                                          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                        </div>
                                        <div className="modal-body">
                                          <div className="px-4">
                                            <div className="form_field">
                                              <label className="fs-14">Title</label>
                                              <div className="input_field">
                                                <input className="form-control" placeholder="Edit Answer.." type="text"
                                                  value={editSummaryForm?.title || ""}
                                                  onChange={(e) =>
                                                    setEditSummaryForm({
                                                      ...editSummaryForm,
                                                      title: e.target.value,
                                                    })
                                                  } />
                                              </div>
                                            </div>
                                            <div className="form_field">
                                              <label className="fs-14">Description</label>
                                              <div className="input_field">
                                                <textarea className="form-control" rows="4" placeholder="Edit Descripion.."
                                                  name="Edit Descripion.."
                                                  value={editSummaryForm?.expantion || ""}
                                                  onChange={(e) =>
                                                    setEditSummaryForm({
                                                      ...editSummaryForm,
                                                      expantion: e.target.value,
                                                    })
                                                  } />
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                        <div className="modal-footer border-0 justify-content-center">
                                          <button type="button" className="btn btn-secondary rounded-5 fs-14" data-bs-dismiss="modal">Cancel</button>
                                          <button type="button" className="secondary_btn py-2 px-4 fs-14" onClick={udpateSummary}>Update</button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Questions */}
                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>Questions</h2>
                        </div>
                      </div>
                    </div>
                    <div className='common_content_blk'>
                      <div className='row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-xl-3 g-4'>
                        {allQuestions.map((question, qIndex) => (
                          <div className="col" key={question.question_id} id={question.question_id}>
                            <div className="quiz_card_wrapper">
                              <div className="vstack gap-3 h-100 justify-content-between">
                                {/* Question */}
                                <div>
                                  <div className="flex-grow-1 mb-4">
                                    {/* <h3 className="mb-0 fs-5">
                                      Q{qIndex + 1}. {question.question}
                                    </h3> */}

                                    <h3 className={`mb-0 fs-5 ${question.question_id === hash ? 'text-danger fw-bold' : ''}`}>
                                      {`Q${qIndex + 1}.`} {question.question}
                                    </h3>
                                  </div>

                                  {/* Options */}
                                  <ol className="question_list" type="A">
                                    {question.options.map((option) => (
                                      <li
                                        key={option.label}
                                        className={`question_item ${question.answer === option.label
                                          ? "correct_answer"
                                          : ""
                                          }`}
                                      >
                                        {option.value}
                                      </li>
                                    ))}
                                  </ol>

                                  <div className="flex-grow-1 mt-4 p-3 bg-light">
                                    <div className="mb-0 fs-6 fw-nornal">
                                      <strong className="me-2">Explanation:</strong>
                                      <MarkdownText>{question.explanation}</MarkdownText>
                                    </div>
                                  </div>
                                </div>

                                {/* Edit Button */}
                                <div className="mt-4">
                                  <button
                                    className="secondary_btn py-2 px-4 w-100 justify-content-center"
                                    data-bs-toggle="modal"
                                    data-bs-target={`#editModal-${question.question_id}`}
                                    onClick={() =>
                                      setEditForm({
                                        question_id: question.question_id,
                                        question: question.question,
                                        options: question.options,
                                        answer: question.answer,
                                        explanation: question.explanation || "",
                                        action_no: question.action_no,
                                        title: question.title,
                                      })
                                    }
                                  >
                                    Edit Question
                                  </button>

                                  {/* Edit Modal */}
                                  <div
                                    className="modal fade"
                                    id={`editModal-${question.question_id}`}
                                    data-bs-backdrop="static"
                                    data-bs-keyboard="false"
                                    tabIndex="-1"
                                  >
                                    <div className="modal-dialog modal-dialog-centered modal-lg">
                                      <div className="modal-content">
                                        <div className="modal-header">
                                          <h5 className="modal-title">
                                            Edit Question {qIndex + 1}
                                          </h5>
                                          <button
                                            type="button"
                                            className="btn-close"
                                            data-bs-dismiss="modal"
                                          />
                                        </div>

                                        <div className="modal-body px-4">
                                          {/* Question */}
                                          <div className="form_field">
                                            <label className="fs-14">
                                              Question
                                            </label>
                                            <textarea
                                              className="form-control"
                                              rows="4"
                                              value={editForm?.question || ""}
                                              onChange={(e) =>
                                                setEditForm({
                                                  ...editForm,
                                                  question: e.target.value,
                                                })
                                              }
                                            />
                                          </div>

                                          {/* Answers */}
                                          {editForm?.options.map(
                                            (option, idx) => (
                                              <div
                                                className="form_field"
                                                key={option.label}
                                              >
                                                <label className="fs-14">
                                                  Answer {option.label}.
                                                </label>

                                                <input
                                                  type="text"
                                                  className={`form-control ${editForm.answer ===
                                                    option.label
                                                    ? "correct_answer"
                                                    : ""
                                                    }`}
                                                  value={option.value}
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value;

                                                    setEditForm((prev) => ({
                                                      ...prev,
                                                      options: prev.options.map(
                                                        (opt, i) =>
                                                          i === idx
                                                            ? { ...opt, value }
                                                            : opt
                                                      ),
                                                    }));
                                                  }}
                                                />
                                              </div>
                                            )
                                          )}

                                          {/* Explanation */}
                                          <div className="form_field">
                                            <label className="fs-14">
                                              Explanation
                                            </label>
                                            <textarea
                                              className="form-control"
                                              rows="4"
                                              value={editForm?.explanation || ""}
                                              onChange={(e) =>
                                                setEditForm({
                                                  ...editForm,
                                                  explanation: e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="modal-footer border-0 justify-content-center">
                                          <button
                                            className="btn btn-secondary rounded-5 fs-14"
                                            data-bs-dismiss="modal"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            className="secondary_btn py-2 px-4 fs-14"
                                            onClick={() => {
                                              const modal =
                                                new window.bootstrap.Modal(
                                                  document.getElementById(
                                                    "confirmUpdateModal"
                                                  )
                                                );
                                              modal.show();
                                            }}
                                            disabled={updating}
                                          >
                                            {updating
                                              ? "Updating..."
                                              : "Update"}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div
              className="modal fade"
              id="confirmUpdateModal"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Confirm Update</h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                    ></button>
                  </div>

                  <div className="modal-body">
                    Are you sure you want to update this question?
                  </div>

                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary rounded-5 fs-14"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="secondary_btn py-2 px-4 fs-14"
                      onClick={updateQuestion}
                    >
                      Yes, Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BlackBoxListDetails;
